import type { InstallmentEligibilityApi, InstallmentEligibilityParams } from 'shared/api/installmentEligibility-v2.api'

export class InstallmentEligibilityStore {
  storeName = 'InstallmentEligibilityStore'
  api: InstallmentEligibilityApi

  constructor(api: InstallmentEligibilityApi) {
    this.api = api
  }

  check = (params: InstallmentEligibilityParams) => this.api.check(params)
}
